import React from 'react'

import OptimizedImage from '../components/OptimizedImage'
import SimpleHeader from '../components/SimpleHeader'
import Sidebar from '../components/Sidebar'
import Pagination from '../components/Pagination'

function FeaturedImage({ id, posts }) {
  const post = posts.find(p => p.node.id === id)
  const featuredImage = post && post.node.frontmatter.featuredImage
  return (
    <OptimizedImage
      image={featuredImage}
      style={{ display: 'block' }}
      className="responsive-img"
      defaultImage="http://placehold.it/410x270"
      alt="blog image"
    />
  )
}

function BlogPage({ data: { latestPosts, posts }, pathContext }) {
  const { group } = pathContext
  return (
    <div className="blog">
      <SimpleHeader title="Our Blog" />

      {/*<!-- Start News Section-->*/}
      <section
        id="news"
        data-scroll-index="4"
        className="main-section center-align"
      >
        <div className="container">
          <div className="row">
            <div className="col s12 l8">
              <div className="p-t-2 grid center-align row">
                {group.map(({ node: { id, excerpt, frontmatter } }) => (
                  <div className="single-news col s12 m6" key={id}>
                    {/*<!-- Link to the blog news post -->*/}
                    <a href={frontmatter.path}>
                      <figure>
                        <FeaturedImage id={id} posts={posts.edges} />

                        <figcaption>
                          <span
                            className="overlay gradient-color"
                            style={{ height: '100%' }}
                          />

                          <span className="stats">
                            <span className="search">
                              <i className="fa fa-search" />
                            </span>
                          </span>
                        </figcaption>
                      </figure>
                    </a>

                    <div className="info p-b-1">
                      <p>
                        {/*<!-- Post Writer Name -->*/}
                        <span>
                          <i
                            className="fa fa-user gradient-color"
                            aria-hidden="true"
                          />
                          {frontmatter.author}
                        </span>

                        {/*<!-- Post Date -->*/}
                        <span>
                          <i
                            className="fa fa-calendar gradient-color"
                            aria-hidden="true"
                          />
                          {frontmatter.date}
                        </span>
                      </p>

                      {/*<!-- Post Title -->*/}
                      <a href={frontmatter.path}>
                        <h5>{frontmatter.title}</h5>
                      </a>

                      {/*<!-- Post Excerpt -->*/}
                      <p className="p-b-1">{excerpt}</p>

                      {/*<!-- Post Link -->*/}
                      <a
                        href={frontmatter.path}
                        className="shadow-button waves-effect waves-light"
                      >
                        Read more
                        <i className="fa fa-arrow-right" />
                      </a>
                    </div>
                  </div>
                ))}
              </div>
              <Pagination data={pathContext} />
            </div>

            <Sidebar latestPosts={latestPosts.edges} />
          </div>
        </div>
      </section>
      {/*<!-- End News Section-->*/}

      {/*<!-- Start Subscribe Section-->*/}
      <section id="subscribe" className="main-section center-align">
        <div className="container row">
          <div className="subscribe-container">
            <div className="col s12 l4">
              <h4 className="title p-b-2">Subscribe</h4>
            </div>

            {/*<!-- Subscription Form -->*/}
            <form
              id="subscribe-form"
              name="subscribe-form"
              className="subscribe-input input-field col s12 l8"
            >
              {/*<!-- Email Field -->*/}
              <input
                name="subscribe-email"
                id="subscribe-email"
                type="email"
                className="validate"
              />

              <label data-error="Invalid Email" htmlFor="subscribe-email">
                Email
              </label>

              {/*<!-- Submit Button -->*/}
              <button
                id="subscribe-submit"
                className="gradient-color waves-effect waves-light"
                type="submit"
              >
                <i className="fa fa-paper-plane first" />

                <i className="fa fa-paper-plane second" />
              </button>

              {/*<!-- ! Anti-spam field ! Invisible for users, it will trick most bots to fill it and prevent the email from being sent to you -->*/}
              <div className="input-field col s12 hidden">
                <input
                  type="text"
                  id="subscribe-check-spam"
                  placeholder="Leave field empty"
                  name="check-spam"
                />
              </div>
            </form>
          </div>

          {/*<!-- Alert Message -->*/}
          <div
            className="col s12 alert-message p-t-2"
            id="subscribe-alert-message"
          />
        </div>
      </section>
      {/*<!-- End Subscribe Section-->*/}
    </div>
  )
}

export default BlogPage

// cannot use childImageSharp from `createPages`:
// https://github.com/gatsbyjs/gatsby/issues/2628#issuecomment-375242484
export const pageQuery = graphql`
  query IndexQuery {
    latestPosts: allMarkdownRemark(
      filter: { frontmatter: { published: { eq: true } } }
      limit: 4
      sort: { order: DESC, fields: [frontmatter___date] }
    ) {
      ...LatestPostsFragment
    }
    posts: allMarkdownRemark(
      filter: { frontmatter: { published: { eq: true } } }
      sort: { order: DESC, fields: [frontmatter___date] }
      limit: 1000
    ) {
      edges {
        node {
          id
          frontmatter {
            featuredImage {
              childImageSharp {
                sizes(maxWidth: 410, maxHeight: 270) {
                  ...GatsbyImageSharpSizes_noBase64
                }
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/blog.js